import Http from './http'

const BASE_URL = "/api/home"

export default {
  async login(user) {
    return Http.post(`${BASE_URL}/login`, user)
  },
  async index() {
    return Http.get(`${BASE_URL}/index`)
  },
  async userSettingGet() {
    return Http.get(`${BASE_URL}/user-setting`)
  },
  async userSettingPost(user) {
    return Http.post(`${BASE_URL}/user-setting`, user)
  },
  async changePassword(pwdInfo) {
    return Http.post(`${BASE_URL}/change-password`, pwdInfo)
  },
  async register(data) {
    return Http.post(`${BASE_URL}/register`, data)
  },
  async permits(all) {
    return Http.get(`${BASE_URL}/permits`, all ? {all: true} : undefined)
  },
  async updateToken() {
    return Http.post(`${BASE_URL}/update-token`)
  },
  async dicts(dicts) {
    return Http.get(`${BASE_URL}/dicts`, {dicts: dicts})
  },
}




// WEBPACK FOOTER //
// ./src/api/home.js